module.exports = __webpack_public_path__ + "img/web_morse_1.c0b2b936.jpg";